import { render, staticRenderFns } from "./cucoloris.vue?vue&type=template&id=6153c0a8"
import script from "./cucoloris.vue?vue&type=script&lang=js"
export * from "./cucoloris.vue?vue&type=script&lang=js"
import style0 from "./cucoloris.vue?vue&type=style&index=0&id=6153c0a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports